const en = {
  i18nView: {
    login: 'Login',
    account: 'Account',
    currentAccount: 'Account',
    balance: 'Balance',
    logout: 'Logout',
    contract: 'Contract',
    used: 'Used',
    rent: 'Rent',
    contractRamTip: 'If contract\'s RAM is run out, new users can\'t get the token',
    ram: 'RAM',
    digTip: 'Expected per transfer',
    whiteTip: 'Please whitelist this action.',
    airgrabTip: 'Send any amount of EOS to eidosonecoin, the EOS will instantly back to you, and the 0.01% of the EIDOS balance of eidosonecoin will airdrop to your account too',
    enableAuto: 'Automatic Transfer',
    stopAuto: 'Stop Automatic',
    eidosTitle: 'Airdrop Miner',
    error: 'Error: ',
    trade: 'Trade',
    fastMode: 'Ultra-Fast Mode',
    digTime: 'Mining times',
    changeNode: 'Change Node',
    diggingSetting: 'When the expected per transfer is greater than',
    diggingSetting1: 'start transfer',
    cpuTips: 'It will failed when your CPU & NET is exceeds 100%',
    settingTips: 'There will be errors cause of the fluctuation of CPU and timing',
    advSetting: 'Settings',
    cpuQuota: 'CPU Quota ',
    cpuQuotaTip: '(Stop mining when the quota is reached, 0 is unlimited by default)',
    notEnough: 'Insufficient ',
    left: 'Left',
    actionsPerTx: 'Speed:',
    actionsPerTxTip: 'High speed will cost more CPU to get more EIDOS',
    bpBlocker: 'Smart Mode',
    bpBlockerTip: 'Try to select high-efficiency BP reducing CPU cost (about 30%) . It has a strong dependence with user\'s network and selected node. Very slow',
    fastModeTip: 'Increase mining speed, Not compatible with Smart Mode for now. Action Whitelist required.',
    randomNode: 'Random Node',
    startTransfer: 'Start Transfer...',
    success: 'Success!',
    failed: 'Failed',
    nodeChanged: 'Node Changed!',
    noMatch: 'Canceled, doesn\'t meet the set conditions',
    cpuNotEnough: 'CPU is not enough!',
    swapYas: 'YAS Mapping',
    miningTips: 'The number of miner users is large, resulting in node instability. If you are always unable to mine, you can try other mining tools in the TP wallet'
  }
};

export default en;